import {
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  VStack,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Controller, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form';
import type { EnrolmentSettingsDataTypes } from './UpdateEnrolmentFormFields';

interface SemesterFreeFieldProps {
  semester: 1 | 2;
  control: Control<EnrolmentSettingsDataTypes>;
  register: UseFormRegister<EnrolmentSettingsDataTypes>;
  isFree: boolean;
  isDisabled: boolean;
  errors: FieldErrors<EnrolmentSettingsDataTypes>;
}

export function SemesterFreeField({
  semester,
  control,
  register,
  isFree,
  isDisabled,
  errors,
}: SemesterFreeFieldProps) {
  const fieldName = semester === 1 ? 'sem1IsFree' : 'sem2IsFree';
  const reasonFieldName = semester === 1 ? 'sem1FreeReason' : 'sem2FreeReason';

  return (
    <VStack w="full" align="start" gap="8px">
      <FormControl>
        <Controller
          name={fieldName}
          control={control}
          render={({ field }) => (
            <Checkbox
              id={fieldName}
              isChecked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              isDisabled={isDisabled}
            >
              <Trans>Don't invoice for Semester {semester}</Trans>
            </Checkbox>
          )}
        />
      </FormControl>

      {isFree ? (
        <FormControl isInvalid={!!errors[reasonFieldName]} isRequired>
          <FormLabel htmlFor={reasonFieldName} fontSize="sm">
            <Trans>Why isn't Semester {semester} being invoiced?</Trans>
          </FormLabel>
          <Input
            id={reasonFieldName}
            placeholder={t`e.g., "Transferred from superseded course" or "Already invoiced in previous enrolment"`}
            {...register(reasonFieldName, {
              required: isFree ? t`Please explain why this semester won't be invoiced` : false,
            })}
          />
          <FormErrorMessage>{errors[reasonFieldName]?.message}</FormErrorMessage>
        </FormControl>
      ) : null}
    </VStack>
  );
}
